export const SETENGLISHPOSITIVERESPONSE = 'SETENGLISHPOSITIVERESPONSE'
export const SETENGLISHNEGATIVERESPONSE = 'SETENGLISHNEGATIVERESPONSE'
export const SETSPANISHPOSITIVERESPONSE = 'SETSPANISHPOSITIVERESPONSE'
export const SETSPANISHNEGATIVERESPONSE = 'SETSPANISHNEGATIVERESPONSE'
